export type ConversationRegionSelection = {
  countryCode: string;
  countryName: string;
  languageCode: string;
  languageName: string;
  languageLocale: string;
};

let currentSelection: ConversationRegionSelection | null = null;

export function setConversationRegionSelection(
  selection: ConversationRegionSelection | null
): void {
  currentSelection = selection;
}

export function getConversationRegionSelection(): ConversationRegionSelection | null {
  return currentSelection;
}

/** Metadata fields merged into chat API `metadata` payload. */
export function getConversationRegionChatMetadata(): Record<string, unknown> | null {
  if (!currentSelection) return null;
  return {
    country_code: currentSelection.countryCode,
    country_name: currentSelection.countryName,
    language: {
      code: currentSelection.languageCode,
      name: currentSelection.languageName,
    },
    language_locale: currentSelection.languageLocale,
  };
}
